import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import testProductBg from "resources/test/testProductBg.png";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import style from "./ProductCard.module.css";
import rank1Icon from "resources/img/puffu/rank1.png";
import rank2Icon from "resources/img/puffu/rank2.png";
import rank3Icon from "resources/img/puffu/rank3.png";
import { useTouchClick } from "shared/hooks/useTouchClick";
import { requester } from "App";
import { toast } from "react-toastify";
import Dummy from "components/Dummy";


function SoldOutProductCard(props) {
    const { isMobile } = useContext(BrowserDetectContext);
    const { data , vertical } = props;

    const onClickProduct = () => {
        let reviewData = {
            productId: data.productId
        }
        requester.productReviewCount(reviewData, (result) => {
            if (result.code === 0) {
                props.setViewData((prevData) => ({
                    ...prevData,
                    detailYn: true,
                    detailProduct: data,
                    view: props.filter ? props.filter : null,
                    reviewCount: result.data.count
                }));
            }
        })
    };

    const addCartClick = () => {
        toast.error("품절된 상품입니다.", {
            autoClose: 1000,
            position: toast.POSITION.BOTTOM_CENTER
        });
    };

    const { handleTouchStart: productTouchStart, handleTouchEnd: productTouchEnd } = useTouchClick(onClickProduct, 50, (deltaX, deltaY) => {
    });
    const { handleTouchStart: cartTouchStart, handleTouchEnd: cartTouchEnd } = useTouchClick(addCartClick, 10);

    const getRankIcon = (rank) => {
        switch (rank) {
            case 1:
                return rank1Icon;
            case 2:
                return rank2Icon;
            case 3:
                return rank3Icon;
            default:
                return null;
        }
    }

    const rankIcon = props.filterProduct ? null : getRankIcon(data.productRank);

    return (
        <div
            style={{
                display: "flex",
                flex: props.flex ? props.flex : "1 0 20%",
                maxWidth: "20%",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "3px"
            }}
        >
            <div
                style={{
                    width: "100%",
                    position: "relative"
                }}
            >
                <div className={style.rankLabel}>
                    <VerticalFlex width={"max-content"} gap={5}>
                        {
                            data.productRank !== null &&
                            <FlexChild>
                                <img src={rankIcon} width={"30px"} />
                            </FlexChild>
                        }
                        {
                            data.sales || data.productRank !== null
                                ?
                                <FlexChild>
                                    <div className={style.best}>
                                        <P color={"white"} size={12} font={"Pretendard"} weight={700}>BEST</P>
                                    </div>
                                </FlexChild>
                                :
                                null
                        }
                        {
                            data.newYn &&
                            <FlexChild>
                                <div className={style.new}>
                                    <P color={"white"} size={12} font={"Pretendard"} weight={700}>NEW</P>
                                </div>
                            </FlexChild>
                        }
                    </VerticalFlex>
                </div>

                <VerticalFlex gap={10}>
                    <FlexChild>
                        <div className={style.productCard}>
                            <VerticalFlex>
                                {/* <FlexChild backgroundImage={data.productBgImg ? `url(${data.productBgImg})` : `url(${testProductBg})`} backgroundSize={"cover"}> */}
                                <FlexChild backgroundImage={data.productBgImg ? `url(${data.productBgImg})` : ``} backgroundSize={"cover"}>
                                    <div style={{ position: "relative" }}>
                                        <div style={{ pointerEvents: "none", position: "absolute", display: "flex", transform: "translateY(100px)", justifyContent: "center", alignItems: "center", zIndex: 1 }}>

                                            <P font={"Pretendard"} size={isMobile ? "2vw" : 30} color={"var(--point-color)"} weight={700}>
                                                SOLD OUT
                                            </P>
                                        </div>
                                        <div
                                            style={{
                                                borderTopLeftRadius: "3px",
                                                borderTopRightRadius: "3px",
                                                padding: "5px",
                                                display: "flex",
                                                width:vertical ? "207px" : "auto",
                                                maxWidth: "207px",
                                                maxHeight: "207px",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                opacity: 0.3,
                                                position: "relative"
                                            }}
                                            onPointerDown={productTouchStart}
                                            onPointerUp={productTouchEnd}
                                        >
                                             <img src={data.productImg} width={"max-content"} height={vertical ? "207px" : "207px"} style={{transform: vertical ? "translateX(20px)":"translateX(20px)" }} />
                                        </div>
                                    </div>
                                </FlexChild>
                                <FlexChild>
                                    <Center width={"130px"}>
                                        <Dummy height={"10px"} />
                                        <P font={"Pretendard"} weight={700} ellipsis size={isMobile ? "1vw" : 15}>
                                            {data.productName}
                                        </P>
                                        <P font={"Pretendard"} weight={700} color={"var(--point-color)"} size={"1.2vw"}>
                                            {data.price ? data.price.toLocaleString() : '가격 없음'}원
                                        </P>
                                        <Dummy height={"5px"} />
                                    </Center>
                                </FlexChild>
                            </VerticalFlex>
                        </div>
                    </FlexChild>
                    {
                        props.filter === 'exhibition' ?
                            null
                            :
                            <FlexChild width={"100%"}>
                                <div className={style.addCartButton} onPointerDown={cartTouchStart} onPointerUp={cartTouchEnd}>
                                    <Center>
                                        <P
                                            size={24}
                                            width={"100%"}
                                            color={"white"}
                                            padding={"8px 15px"}
                                            cursor={"pointer"}
                                            font={"Pretendard"}
                                            weight={700}
                                        >
                                            상품 담기
                                        </P>
                                    </Center>
                                </div>
                            </FlexChild>
                    }
                </VerticalFlex>
            </div>
        </div>
    );
};

export default SoldOutProductCard;